import { LIMITS_DATA, LIMITS_ERROR_DATA, LIMITS_HIDE_ERROR_DATA, LIMITS_START_LOADER, LIMITS_STOP_LOADER } from "../interface/ILimits";
const initState = {
    limits: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const limits = (state = initState, action) => {
    switch (action.type) {
        case LIMITS_DATA:
            return Object.assign(Object.assign({}, state), { limits: action.payload.limits });
        case LIMITS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case LIMITS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        case LIMITS_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case LIMITS_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        default:
            return Object.assign({}, state);
    }
};
export default limits;
